'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends7 = require('babel-runtime/helpers/extends');

var _extends8 = _interopRequireDefault(_extends7);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.load = load;
exports.save = save;
exports.editStart = editStart;
exports.editStop = editStop;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'redux-example/widgets/LOAD';
var LOAD_SUCCESS = 'redux-example/widgets/LOAD_SUCCESS';
var LOAD_FAIL = 'redux-example/widgets/LOAD_FAIL';
var EDIT_START = 'redux-example/widgets/EDIT_START';
var EDIT_STOP = 'redux-example/widgets/EDIT_STOP';
var SAVE = 'redux-example/widgets/SAVE';
var SAVE_SUCCESS = 'redux-example/widgets/SAVE_SUCCESS';
var SAVE_FAIL = 'redux-example/widgets/SAVE_FAIL';

var initialState = {
  loaded: false,
  editing: {},
  saveError: {}
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends8.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends8.default)({}, state, {
        loading: false,
        loaded: true,
        data: action.result,
        error: null
      });
    case LOAD_FAIL:
      return (0, _extends8.default)({}, state, {
        loading: false,
        loaded: false,
        data: null,
        error: action.error
      });
    case EDIT_START:
      return (0, _extends8.default)({}, state, {
        editing: (0, _extends8.default)({}, state.editing, (0, _defineProperty3.default)({}, action.id, true))
      });
    case EDIT_STOP:
      return (0, _extends8.default)({}, state, {
        editing: (0, _extends8.default)({}, state.editing, (0, _defineProperty3.default)({}, action.id, false))
      });
    case SAVE:
      return state; // 'saving' flag handled by redux-form
    case SAVE_SUCCESS:
      var data = [].concat((0, _toConsumableArray3.default)(state.data));
      data[action.result.id - 1] = action.result;
      return (0, _extends8.default)({}, state, {
        data: data,
        editing: (0, _extends8.default)({}, state.editing, (0, _defineProperty3.default)({}, action.id, false)),
        saveError: (0, _extends8.default)({}, state.saveError, (0, _defineProperty3.default)({}, action.id, null))
      });
    case SAVE_FAIL:
      return typeof action.error === 'string' ? (0, _extends8.default)({}, state, {
        saveError: (0, _extends8.default)({}, state.saveError, (0, _defineProperty3.default)({}, action.id, action.error))
      }) : state;
    default:
      return state;
  }
}

function isLoaded(globalState) {
  return globalState.widgets && globalState.widgets.loaded;
}

function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/widget/load/param1/param2');
    } // params not used, just shown as demonstration
  };
}

function save(widget) {
  return {
    types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
    id: widget.id,
    promise: function promise(client) {
      return client.post('/widget/update', {
        data: widget
      });
    }
  };
}

function editStart(id) {
  return { type: EDIT_START, id: id };
}

function editStop(id) {
  return { type: EDIT_STOP, id: id };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/widgets.js
// module id = 1299
// module chunks = 0